/**
 * Live OpenTok publisher/session for the current call tab.
 * forceLogout has no React refs — it must read these to release the mic.
 */
let livePublisher = null;
let liveSession = null;

export function setLiveCallMedia({ publisher, session } = {}) {
  if (publisher !== undefined) livePublisher = publisher || null;
  if (session !== undefined) liveSession = session || null;
}

export function getLiveCallMedia() {
  return { publisher: livePublisher, session: liveSession };
}

export function clearLiveCallMedia() {
  livePublisher = null;
  liveSession = null;
}
